import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { urlUtility } from "@repo/utilities/url.utility.ts";

interface IGetAllKnockoutQuestionsServiceProps {
  page?: string;
  per_page?: string;
  enableQuery?: boolean;
}

// Get Api service for Knockout Questions
export const useGetAllKnockoutQuestionsService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetAllKnockoutQuestionsServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const knockoutId = urlQueries["knockout-id"];

  const allKnockoutQuestionsServices = useQuery({
    queryKey: [...CACHE_KEYS.KNOCKOUT_QUESTIONS, page, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.KNOCKOUT_QUESTIONS,
        searchParams: {
          page,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  const singleKnockoutQuestionsService = useQuery({
    queryKey: ["knockout_question", knockoutId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.KNOCKOUT_QUESTIONS}/${knockoutId}`,
      }),
    enabled: knockoutId ? true : false,
  });

  return {
    services: { allKnockoutQuestionsServices, singleKnockoutQuestionsService },
  };
};
